import React from 'react';

interface CheckboxProps {
  id: string;
  checked?: boolean;
  indeterminate?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  ariaLabel?: string;
  label?: string;
  variant?: 'icon' | 'with-label';
}

export const Checkbox: React.FC<CheckboxProps> = ({
  id,
  checked = false,
  indeterminate = false,
  onChange,
  disabled = false,
  ariaLabel,
  label,
  variant = 'icon'
}) => {
  const inputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  // Determine wrapper class based on variant
  const wrapperClass = variant === 'with-label' 
    ? 'core-checkbox-wrapper core-checkbox-wrapper--with-label' 
    : 'core-checkbox-wrapper';

  return (
    <div className={wrapperClass}>
      <input
        ref={inputRef}
        type="checkbox"
        id={id}
        className="core-checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        aria-label={ariaLabel || label}
      />
      <label htmlFor={id} className="core-checkbox-label">
        <span className="core-checkbox-inner">
          <span className="core-checkbox-checkmark" />
        </span>
        {variant === 'with-label' && label && (
          <span className="core-checkbox-text">{label}</span>
        )}
      </label>
    </div>
  );
};

export default Checkbox;
